export default __webpack_public_path__ + "static/media/Lion_s Claws.134348e3.png";